<template>
    <div>
        <v-row align="end">
            <v-col> <h5 class="page-text--lg">문자발송</h5> </v-col> <v-spacer />
            <v-col cols="auto"> <texting-form-point /> </v-col>
        </v-row>
        <vertical-form-table v-model="form" v-bind="{ items }" class="mt-8 mt-lg-16">
            <template #회사명 v-if="!!recruitment?._id"> {{ recruitment?.company?.name || user?.name || "-" }} </template>
            <template #회사명 v-else>
                ??
                <v-text-field v-model="form.addresser.company" v-bind="attrs_input" auto-grow placeholder="회사명을 적어주세요." />
            </template>

            <!-- <template #담당자명 v-if="recruitment"> {{ recruitment?.recruiter?.name || "-" }} </template>
            <template #담당자명 v-else>
                <v-text-field v-model="form.addresser.name" v-bind="attrs_input" auto-grow placeholder="담당자명을 적어주세요." />
            </template> -->
            <template #담당자명>
                <v-text-field v-model="form.addresser.name" v-bind="attrs_input" auto-grow placeholder="담당자명을 적어주세요." />
            </template>
            <!-- 
            <template #연락처 v-if="recruitment"> {{ recruitment?.recruiter?.phone || "-" }} </template>
            <template #연락처 v-else>
                <v-text-field v-model="form.addresser.phone" v-bind="attrs_input" auto-grow placeholder="연락처를 적어주세요."/>
            </template> -->
            <template #연락처>
                <v-text-field v-model="form.addresser.phone" v-bind="attrs_input" auto-grow placeholder="연락처를 적어주세요." />
            </template>

            <template #발송번호>
                <texting-form-addressees v-model="form.addressees" :items="addresseeItems" :readonly="readonlyAddressees" v-bind="attrs_input" />
            </template>
            <template #문자내용>
                <v-textarea v-model="form.message" v-bind="attrs_input" auto-grow />
            </template>
            <template #미리보기>
                <v-textarea :value="preview" readonly auto-grow rows="1" :hide-details="false" v-bind="attrs_input" counter :counterValue="counterValue" class="preview-textarea mb-n8"> </v-textarea>
            </template>
            <template #차감포인트> {{ previewPointTotal?.format?.() || 0 }}원 (건당 {{ previewPointPerItem?.format?.() }}원) </template>
        </vertical-form-table>
        <v-layout justify-center class="mt-20 mt-lg-40">
            <v-btn v-bind="{ loading }" color="primary" class="min-w-100px min-w-lg-140px" @click="post">문자발송</v-btn>
        </v-layout>
    </div>
</template>

<script>
import api from "@/api";
import { mapState } from "vuex";
import { attrs_input, initMeeting, initRecruitment, initTexting, initTextingAddressee } from "@/assets/variables";

import TextingFormPoint from "./texting-form-point.vue";
import VerticalFormTable from "@/components/dumb/vertical-form-table.vue";
import TextingFormAddressees from "./texting-form-addressees.vue";

const items = [
    { term: "회사명" },
    { term: "담당자명" },
    { term: "연락처" },
    {
        key: "addresses",
        term: "발송번호",
    },
    {
        key: "message",
        term: "문자내용",
    },
    { term: "미리보기" },
    { term: "차감포인트" },
];

export default {
    components: {
        TextingFormPoint,
        VerticalFormTable,
        TextingFormAddressees,
    },
    props: {
        initialForm: { type: Object, default: () => ({}) },

        meeting: { type: Object, default: initMeeting },
        // recruitment: { type: Object, default: initRecruitment },
        recruitment: { type: Object, default: null },
        applications: { type: Array, default: () => [] },
        readonlyAddressees: { type: Boolean, default: false },
    },
    data: () => ({
        form: initTexting(),

        loading: false,

        items,
        attrs_input,
    }),
    computed: {
        ...mapState(["user"]),
        preview() {
            let preview = "[마이스펙] ";

            let previewItems = [];

            this.form.addresser.company = this.recruitment?.company?.name || this?.user?.name;
            if (this.form?.addresser?.company) preview += ` 기업명: ${this.form.addresser.company}`;
            if (this.form?.addresser?.name) preview += `\n 담당자: ${this.form.addresser.name}`;
            if (this.form?.addresser?.phone) preview += `\n 연락처: ${this.form.addresser.phone}`;

            if (previewItems.length) preview += previewItems.join("\n");
            preview = preview.trim() + "\n";

            if (this.form?.message) preview += this.form?.message?.trim?.();

            return preview.trim();
        },
        previewBytes() {
            return [...(this.preview || "")].reduce((sum, char) => sum + (escape(char).length > 4 ? 2 : 1), 0);
        },
        previewType() {
            return (this.previewBytes || 0) <= 90 ? "SMS" : "LMS";
        },
        previewLimit() {
            return { SMS: 90, LMS: 2000 }[this.previewType] || 90;
        },
        previewPointPerItem() {
            return { SMS: 25, LMS: 50 }[this.previewType] || 25;
        },
        previewPointTotal() {
            return this.previewPointPerItem * (this.form?.addressees?.length || 0);
        },
        addresseeItems() {
            return this.applications.map(initTextingAddressee);
        },
        isPointInsufficient() {
            return this.$store.state.user?.point < this.previewPointTotal;
        },
    },
    mounted() {
        this.init();
    },
    watch: {
        initialForm() {
            this.init();
        },
        recruitment() {
            this.init();
        },
    },
    methods: {
        init() {
            this.loading = false;
            this.form = initTexting({
                ...this.initialForm,
                _meeting: this.meeting?._id,
                _recruitment: this.recruitment?._id,
                addresser: {
                    _user: this.$store.state?.payload?._user,
                    name: this.recruitment?.recruiter?.name || this?.user?.name,
                    phone: this.recruitment?.recruiter?.phone,
                    email: this.recruitment?.recruiter?.email,
                },
            });
        },
        async post() {
            if (this.isPointInsufficient) {
                alert("포인트가 부족합니다");
                return;
            }

            if (this.loading) return;
            else this.loading = true;

            try {
                const { ...form } = this.form;
                form.message = this.preview;
                let { texting } = await api.v1.company.textings.post(form);
                this.$emit("posted", texting);
                alert("발송되었습니다");
            } finally {
                this.init();
                this.loading = false;
            }
        },
        counterValue() {
            return `${this.previewBytes?.format?.() || 0} / ${this.previewLimit?.format?.() || 0} Bytes [${this.previewType}]`;
        },
    },
};
</script>

<style lang="scss" scoped>
.preview-textarea ::v-deep {
    textarea {
        height: initial;
        min-height: initial;
    }
    .v-text-field__details {
        max-height: initial;
        min-height: initial;
    }
}
</style>
